/**
 * The telemetry level type and the one rule that combines its inputs, in a
 * module that imports NOTHING (DHT-5279).
 *
 * Split out of `telemetryLevel.ts` because that module reaches storage, which
 * reaches the logger, which reaches the Datadog SDK. Anything wanting only the
 * rule (the settings screen, the gate, their tests) would otherwise pay for
 * that whole chain at import time, which is most of a second in a test suite.
 * `telemetryLevel.ts` re-exports both, so existing importers are unaffected.
 */

/**
 * How much Datadog telemetry a device collects.
 *
 * - `full`, everything, the shipped default.
 * - `noReplay`, RUM events and errors still collected, Session Replay off.
 *   WEB ONLY: there is no native replay package, so the settings UI does not
 *   offer this rung on native.
 * - `off`, no collection at all.
 */
export type TelemetryLevel = "full" | "noReplay" | "off";

/**
 * How the kill switch and the device setting combine, in one place.
 *
 * Both the runtime gate and the settings screen need this answer, and they need
 * the same one: if they derived it separately, adding a third input later would
 * gate the SDK one way while telling the operator something else.
 */
export const effectiveTelemetryLevel = (
  killSwitchOn: boolean,
  deviceLevel: TelemetryLevel,
): TelemetryLevel => (killSwitchOn ? "off" : deviceLevel);
